import React from 'react';
import Button from './Button';
import classes from './Card.module.css';
const Card = props => {
    return (<div className={classes['single-card']}>
        <div className="row justify-content-evenly">
            <div className="col-3 text-center">
                <img src={props.src} alt="" className={classes['card-img']} />
            </div>
            <div className="col-6  d-flex align-items-center">
                <div>
                    <div className={` ${classes['card-title']}`}><h3>{props.title}</h3></div>

                    <div className={classes['card-details']}>{props.content}</div>
                </div>
            </div>
            <div className="col-2  d-flex align-items-center ">
                <div className="button"><Button content="Add To Cart" /></div>
            </div>

        </div>





    </div>

    )
}
export default Card;